import axios from 'axios'

/*
* production:  https://plataforma.m68.mx/api
* development: https://stage.m68.mx/api
*/

const instance = axios.create({
  baseURL: 'https://plataformam68.unam.mx/api'
})

export default instance
